enum Actions {
	SET_MESSAGES = '[AIChat] SET_MESSAGES',
	SET_LOADING = '[AIChat] SET_LOADING',
	SET_MESSAGE = '[AIChat] SET_MESSAGE',
	SET_MESSAGE_ERROR = '[AIChat] SET_MESSAGE_ERROR',
	SET_FEEDBACK = '[AIChat] SET_FEEDBACK',
	SET_REASONING_FOR_MESSAGE_ID = '[AIChat] SET_REASONING_FOR_MESSAGE_ID',
	CLEAR_MESSAGES = '[AIChat] CLEAR_MESSAGES',
	SET_CURRENT_CHAT_ID = '[AIChat] SET_CURRENT_CHAT_ID',
	SET_CHATS = '[AIChat] SET_CHATS',
	ADD_CHAT = '[AIChat] ADD_CHAT',
	UPDATE_CHAT = '[AIChat] UPDATE_CHAT',
	DELETE_CHAT = '[AIChat] DELETE_CHAT',
	MARK_CHAT_AS_READ = '[AIChat] MARK_CHAT_AS_READ',
	INCREMENT_UNREAD_COUNT = '[AIChat] INCREMENT_UNREAD_COUNT',
	SET_SIDEBAR_EXPANDED = '[AIChat] SET_SIDEBAR_EXPANDED'
}

export default Actions;
